import { render, staticRenderFns } from "./StudentsBlacklist.vue?vue&type=template&id=1e6a53b4&scoped=true&"
import script from "./StudentsBlacklist.vue?vue&type=script&lang=js&"
export * from "./StudentsBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./StudentsBlacklist.vue?vue&type=style&index=0&id=1e6a53b4&lang=scss&scoped=true&"
import style1 from "./StudentsBlacklist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a53b4",
  null
  
)

export default component.exports